import { Feature } from '@tencent/workbench';
import { config } from './config';
import { AddOrRemoveSlide } from '@src/framework/frame/components/tool-bar/add-or-remove-slide';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';

@Feature()
export class InsertBlankSlideFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;
    private addOrRemoveSlide: AddOrRemoveSlide;
    public constructor() {
        super();
        this.addOrRemoveSlide = new AddOrRemoveSlide();
    }

    public onClick() {
        this.addOrRemoveSlide.addPcBlankSlide();
    }

    public shouldHide(): boolean {
        return !!this.getAppService().editableServiceLayer?.masterLayoutEditService.isMasterEditType;
    }
}
